/* KJ Bewegung (Schritt 2, 03.11.2026): Einblenden beim Scrollen, Produktbild-Uebergang, Wischgesten.
   Alles ohne Bibliothek. Bei "Bewegung reduzieren" laeuft nur der Wischgesten-Teil. */
(function () {
  'use strict';
  var d = document;
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var sKey = function (k, v) { try { if (v === undefined) return sessionStorage.getItem(k); if (v === null) sessionStorage.removeItem(k); else sessionStorage.setItem(k, v); } catch (e) { return null; } };

  /* ---------- 1. Einblenden beim Scrollen ---------- */
  var REVEAL = [
    '#MainContent .card-wrapper',
    '#MainContent .image-with-text__media-item',
    '#MainContent .icon-text-wrapper',
    '#MainContent .kj-press__item',
    '#MainContent .multicolumn-card',
    '#MainContent .kjai__img, #MainContent .kjav__media, #MainContent .kjvi__img',
    '#MainContent .kjac__card, #MainContent .kjat__item',
    '#MainContent .kj-cat, #MainContent .kj-story__media, #MainContent .kj-story__item, #MainContent .kj-orn'
  ].join(',');
  var IMG = '.image-with-text__media-item, .kjai__img, .kjav__media, .kjvi__img, .kj-story__media';

  function setupReveal() {
    if (reduce || !('IntersectionObserver' in window)) return;
    var vh = window.innerHeight;
    var items = [].slice.call(d.querySelectorAll(REVEAL)).filter(function (el) {
      if (el.parentElement.closest('.kj-reveal') || el.closest('cart-drawer, .drawer, .menu-drawer, .quick-add-modal')) return false;
      var r = el.getBoundingClientRect();
      if (!r.width || !r.height) return false;          /* versteckt */
      return r.top > vh * 0.92;                         /* nur was beim Laden noch unten liegt */
    });
    if (!items.length) return;
    items.forEach(function (el) { el.classList.add('kj-reveal'); if (el.matches(IMG)) el.classList.add('kj-reveal--img'); });
    var io = new IntersectionObserver(function (entries) {
      var batch = entries.filter(function (e) { return e.isIntersecting; }).map(function (e) { return e.target; });
      batch.sort(function (a, b) { var ra = a.getBoundingClientRect(), rb = b.getBoundingClientRect(); return (ra.top - rb.top) || (ra.left - rb.left); });
      batch.forEach(function (el, i) {
        el.style.setProperty('--kj-d', Math.min(i, 5) * 60 + 'ms');
        el.classList.add('kj-in');
        io.unobserve(el);
        setTimeout(function () { el.classList.remove('kj-reveal', 'kj-reveal--img', 'kj-in'); el.style.removeProperty('--kj-d'); }, 1800);
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.12 });
    items.forEach(function (el) { io.observe(el); });
  }

  /* ---------- 2. Produktbild gleitet von der Kachel auf die Produktseite (und zurueck) ---------- */
  var VT = 'kj-pimg', lastImg = null;
  function mainImg() {
    return d.querySelector('.product__media-list > .product__media-item.is-active .product__media img') ||
           d.querySelector('.product__media-list > .product__media-item:first-child .product__media img');
  }
  d.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('a[href*="/products/"]');
    if (!a || e.metaKey || e.ctrlKey || e.shiftKey || a.target === '_blank') { lastImg = null; return; }
    var card = a.closest('.card-wrapper');
    lastImg = card ? card.querySelector('.card__media img') : null;
    sKey('kj-vt', lastImg ? '1' : null);
  }, true);
  window.addEventListener('pageswap', function (e) {
    if (!e.viewTransition) return;
    var to = (e.activation && e.activation.entry && e.activation.entry.url) || '';
    var onProduct = location.pathname.indexOf('/products/') > -1;
    var el = null;
    if (lastImg && to.indexOf('/products/') > -1) el = lastImg;
    else if (onProduct && to.indexOf('/products/') < 0) el = mainImg();
    if (el) el.style.viewTransitionName = VT;
  });
  if (location.pathname.indexOf('/products/') > -1) sKey('kj-vt-back', location.pathname.replace(/^.*\/products\//, '').split('/')[0]);

  /* ---------- 3. Wischgesten: Schubladen mit dem Finger zuschieben ---------- */
  function project(v) { var dr = 0.998; return (v / 1000) * dr / (1 - dr); }
  function swipe(panel, dir, close) {
    if (!panel || panel.dataset.kjSwipe) return;
    panel.dataset.kjSwipe = '1';
    panel.classList.add('kj-swipe');
    var sx = 0, sy = 0, dx = 0, w = 0, active = false, locked = false, hist = [];
    panel.addEventListener('pointerdown', function (e) {
      if (e.pointerType !== 'touch') return;
      if (e.target.closest('input[type=range], .custom-price__range, .kj-pr, .kj-sw, .kj-avail-m, .slider, .thumbnail-slider')) return;
      sx = e.clientX; sy = e.clientY; dx = 0; w = panel.getBoundingClientRect().width; active = true; locked = false; hist = [{ x: sx, t: e.timeStamp }];
    }, { passive: true });
    panel.addEventListener('pointermove', function (e) {
      if (!active) return;
      var mx = e.clientX - sx, my = e.clientY - sy;
      if (!locked) {
        if (Math.abs(mx) < 10 && Math.abs(my) < 10) return;
        if (Math.abs(my) > Math.abs(mx) || mx * dir < 0) { active = false; return; }   /* senkrecht = scrollen */
        locked = true; panel.classList.add('kj-dragging');
        try { panel.setPointerCapture(e.pointerId); } catch (_) {}
      }
      dx = mx * dir > 0 ? mx : mx * 0.2;                 /* in Gegenrichtung nur zaeh */
      hist.push({ x: e.clientX, t: e.timeStamp }); if (hist.length > 6) hist.shift();
      panel.style.transform = 'translate3d(' + dx + 'px,0,0)';
    }, { passive: true });
    function end() {
      if (!active) return; active = false;
      if (!locked) return;
      panel.classList.remove('kj-dragging');
      var a = hist[0], b = hist[hist.length - 1], dt = Math.max(1, b.t - a.t);
      var v = (b.x - a.x) / dt * 1000;                    /* px/s */
      var landing = dx + project(v);
      var shut = landing * dir > w * 0.5 || v * dir > 900;
      panel.style.transition = 'transform ' + (shut ? 240 : 320) + 'ms cubic-bezier(0.23, 1, 0.32, 1)';
      panel.style.transform = shut ? 'translate3d(' + (dir * w) + 'px,0,0)' : 'translate3d(0,0,0)';
      setTimeout(function () {
        if (shut) close();
        requestAnimationFrame(function () { panel.style.transition = 'none'; panel.style.transform = ''; requestAnimationFrame(function () { panel.style.transition = ''; }); });
      }, shut ? 250 : 330);
    }
    panel.addEventListener('pointerup', end);
    panel.addEventListener('pointercancel', end);
  }
  function setupSwipe() {
    if (!window.matchMedia('(pointer: coarse)').matches) return;
    var cart = d.querySelector('cart-drawer');
    if (cart) swipe(cart.querySelector('.drawer__inner'), 1, function () { if (cart.close) cart.close(); });
    var hd = d.querySelector('header-drawer');
    var menu = d.getElementById('menu-drawer');
    if (hd && menu) swipe(menu, -1, function () { var det = hd.querySelector('details'); var s = det && det.querySelector('summary'); if (det && det.hasAttribute('open') && s) s.click(); });
    var facets = d.querySelector('menu-drawer.mobile-facets__wrapper');
    if (facets) swipe(facets.querySelector('.mobile-facets__inner'), 1, function () { var det = facets.querySelector('details'); var s = det && det.querySelector('summary'); if (det && det.hasAttribute('open') && s) s.click(); });
  }

  function init() { setupReveal(); setupSwipe(); }
  if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', init); else init();
  d.addEventListener('shopify:section:load', setupSwipe);
  var mc = d.getElementById('ProductGridContainer') || d.getElementById('MainContent');
  if (mc) new MutationObserver(function () { setupSwipe(); }).observe(mc, { childList: true, subtree: true });
})();
